import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/automated-audit-trails/pages/index/index.page';

export const auditTrailsDashboardRoutes: Route[] = [
    {
        path: 'automated-audit-trails',
        children: [],
    },
];

export const auditTrailDataManagementRoutes: Route[] = [
    {
        path: 'automated-audit-trails',
        component: IndexPage,
    },
];

export const auditTrailsConfigurationRoutes: Route[] = [
    {
        path: 'automated-audit-trails',
        children: [],
    },
];
